// Added by sephora-jsx-loader.js
var React = require('react');
// Added by sephora-jsx-loader.js
var wrapComponentRenderModule = require('utils/framework/wrapComponentRender'); // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
var createClass = require('create-react-class')

// Added by sephora-jsx-loader.js
var wrapComponentRender = wrapComponentRenderModule.wrapComponentRender; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
if (process.env.NODE_ENV === 'development' && !React.PropTypes) {
    React.PropTypes = require('prop-types');
}
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
var TestTargetClass;// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
const BccStyleWrapper = require('components/Bcc/BccStyleWrapper/BccStyleWrapper');

// TODO: Move empty to components folder
const Empty = require('pages/Empty/Empty');

const TestTarget = function () {
    this.state = {
        showSkeleton: this.props.skeleton,
        displayComponent: Empty,
        updateProps: null,
        componentHidden: null
    };
};

TestTarget.prototype.asyncRender = 'TestTarget';

TestTarget.prototype.propTypes = {
    testName: React.PropTypes.string.isRequired,
    testComponent: React.PropTypes.string.isRequired,
    testEnabled: React.PropTypes.bool.isRequired
};

TestTarget.prototype.render = function () {
    const {
        testComponent,
        testName,
        testEnabled,
        index,
        isBcc,
        hideTestWithoutCase,
        skeleton,
        ...defaultProps
    } = this.props;

    let componentProps;

    if (isBcc) {

        /* BCC component renders with state.updateProps in swapping tests, and in the case of
        show & hide tests the component renders with its original props. */
        componentProps = this.state.updateProps ? this.state.updateProps : defaultProps;
    } else {
        componentProps = this.state.updateProps ? Object.assign({}, defaultProps,
            this.state.updateProps) : defaultProps;
    }

    let Component = this.state.displayComponent ?
        <this.state.displayComponent {...componentProps} /> : null;

    if (isBcc && !this.state.componentHidden) {
        Component = <BccStyleWrapper
            customStyle={componentProps.styleList}>
            {Component}
        </BccStyleWrapper>;
    }

    if (hideTestWithoutCase && !componentProps.testTarget) {
        return null;
    }

    return this.state.showSkeleton ? skeleton : Component;
};

// Added by sephora-jsx-loader.js
Sephora.Util.InflatorComps.Comps['TestTarget'].class = TestTarget; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
Object.assign(TestTarget.prototype, require('./TestTarget.c.js'));// Added by sephora-jsx-loader.js
var originalDidMount = TestTarget.prototype.componentDidMount;
TestTarget.prototype.componentDidMount = function(){
    //console.log('Non-root componentDidMount Fired: TestTarget');
    if (originalDidMount) {
        originalDidMount.apply(this);
    }
    if (this.ctrlr) {
        this.ctrlr(this.props.ctrlrArgs);
    }
};
//console.log('Applied non-root componentDidMount: TestTarget');
// Added by sephora-jsx-loader.js
TestTarget.prototype.hasCtrlr = 'true';
// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
TestTarget.prototype.class = TestTarget.prototype.displayName = 'TestTarget';
// Added by sephora-jsx-loader.js
TestTarget.prototype.render = wrapComponentRender(TestTarget);
// Added by sephora-jsx-loader.js
// .jsx// Added by sephora-jsx-loader.js

TestTarget.prototype.getInitialState = function() {
    TestTarget.apply(this, this.props.constructorArgs);
    return this.state;
};
TestTarget.prototype.originClass = TestTarget;
TestTargetClass = createClass(TestTarget.prototype);
TestTargetClass.prototype.classRef = TestTargetClass;
Object.assign(TestTargetClass, TestTarget);
module.exports = TestTargetClass;
// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
// Added by sephora-jsx-loader.js

